export default __webpack_public_path__ + "static/media/logo_final.c98a7a26.ai";